import parse from "html-react-parser";
import { Accordion, Card } from "react-bootstrap";

const OfficialResponseToLab = ({ review }) => {
  const hasTitleOrNote = review?.response?.gist || review?.response?.note1;
  return (
    <Accordion className="my-4" flush defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <h6 className="fw-bold text-dark">OFFICIAL RESPONSE TO LAB</h6>
        </Accordion.Header>
        <Accordion.Body>
          {hasTitleOrNote && (
            <Card className="mb-3">
              <Card.Body>
                <Card.Title>
                  <h4>{review?.response?.gist}</h4>
                </Card.Title>
                <Card.Text style={{ whiteSpace: "pre-wrap" }}>
                  {review?.response?.note1 && parse(review?.response?.note1)}
                </Card.Text>
              </Card.Body>
            </Card>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default OfficialResponseToLab;
